import { Candidate } from '../../../candidate/candidate'
import { useBoardContext } from '../../../hooks/use-board'
import { CandidateCard } from '../../../candidate/components/candidate-card'
import React from 'react'

export function DragOverlayCandidate({ candidate }: { candidate: Candidate }) {
    const { showAttributes, showPhone, dragTransform } = useBoardContext()

    return (
        <div
            style={{
                transform: dragTransform,
                opacity: 0.9,
                cursor: 'grabbing',
                overflow: 'hidden',
            }}
        >
            <CandidateCard
                active
                collapsed={!showAttributes}
                showPhone={showPhone}
                candidate={candidate}
            />
        </div>
    )
}
